import NextImage from "../../NextImage";
import DateStamp from "../../DateStamp";
import EndDateStamp from "../../EndDateStamp";
import { ArticleItem } from "styles/jss/News.styles";
import { truncateString } from "utils/helperFunction";
import { useTranslation } from "next-i18next";
import HeadTitle from "./HeadTitle";

export default function TendersItems(post) {
  const { t } = useTranslation(["article"]);
  const {
    id,
    attributes: {
      title,
      slug,
      thumbnail,
      short_description,
      datetime,
      end_datetime,
      type,
    },
  } = post;

  return (
    <ArticleItem type={type}>
      <div className="imageWrapper">
        <div className="overlay">
          {type === "tender" ? (
            <span>{t("tender.tender")}</span>
          ) : (
            type === "auction" && <span>{t("tender.auction")}</span>
          )}
        </div>
        {!!thumbnail.data && (
          <NextImage
            layout={"responsive"}
            width={180}
            height={150}
            objectFit={"cover"}
            src={thumbnail.data?.attributes.formats.thumbnail.url}
            alt={title}
            placeholder="blur"
          />
        )}
      </div>
      <div className="contentWrapper">
        <HeadTitle as={"h2"} url={`/suppliers/tenders-auctions/${id}/${slug}`}>
          {title}
        </HeadTitle>
        <p className="text">{truncateString(short_description, 135)}</p>
        <div className="articleItemFooter">
          <DateStamp date={datetime} time={false} />
          {!!end_datetime && <EndDateStamp date={end_datetime} />}
        </div>
      </div>
    </ArticleItem>
  );
}
